export default {
	READY: 'ready',
	SAVING: 'saving',
}
